import _pt from '../../../node_modules/prop-types/index.js';

var requiredField = function requiredField(defaultValue) {
  var getComparisonValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
    return v;
  };
  return {
    propTypes: {
      required: _pt.bool.isRequired,
      requiredError: _pt.string
    },
    defaultProps: {
      required: defaultValue
    },
    shouldValidate: function shouldValidate(props) {
      return props.required === true;
    },
    getErrors: function getErrors(field, value, props) {
      var comparison = getComparisonValue(value);

      if (comparison === null || comparison === undefined || comparison === "" || comparison === false || Array.isArray(comparison) && comparison.length === 0 || typeof comparison === "string" && !/\S/.test(comparison) // String does not contain any characters that are not whitespace
      ) {
        return [props.requiredError || "".concat(field, " is required")];
      }

      return [];
    }
  };
};

export { requiredField };
